<template>
<div class="chapter">
<div class="inner_page">
<div id="Contents">
<p class="toc-title">Contents</p>
<p class="toc1"><a href="#/xhtml/07_Maps">Maps</a></p>
<p class="toc1"><a href="#/xhtml/08_Authors_note">Author’s note</a></p>
<p class="toca"><a href="#/xhtml/09_Introduction">Introduction: Naming ‘The Few’</a></p>
<p class="toc1"><a href="#/xhtml/10_Prologue">Prologue</a></p>
<p class="toc1a"><a href="#/xhtml/11_Chapter01">1 |    Australia’s ‘Few’</a></p>
<p class="toc1"><a href="#/xhtml/12_Chapter02">2 |    RAAF cadets</a></p>
<p class="toc1"><span href="#/xhtml/13_Chapter03" title="Link target outside of Sample">3 |    The great adventure</span></p>
<p class="toc1"><span href="#/xhtml/14_Chapter04" title="Link target outside of Sample">4 |    War</span></p>
<p class="toc1"><span href="#/xhtml/15_Chapter05" title="Link target outside of Sample">5 |    First wartime operations</span></p>
<p class="toc1"><span href="#/xhtml/16_Chapter06" title="Link target outside of Sample">6 |    Training for war</span></p>
<p class="toc1"><span href="#/xhtml/17_Chapter07" title="Link target outside of Sample">7 |    The Phoney War continues</span></p>
<p class="toc1"><span href="#/xhtml/18_Chapter08" title="Link target outside of Sample">8 |    The Battle of France</span></p>
<p class="toc1"><span href="#/xhtml/19_Chapter09" title="Link target outside of Sample">9 |    Action at last</span></p>
<p class="toc1"><span href="#/xhtml/20_Chapter10" title="Link target outside of Sample">10 |  10 July – 7 August</span></p>
<p class="toc1"><span href="#/xhtml/21_Chapter11" title="Link target outside of Sample">11 |  8–18 August</span></p>
<p class="toc1"><span href="#/xhtml/22_Chapter12" title="Link target outside of Sample">12 |  19–31 August</span></p>
<p class="toc1"><span href="#/xhtml/23_Chapter13" title="Link target outside of Sample">13 |  1–6 September</span></p>
<p class="toc1"><span href="#/xhtml/24_Chapter14" title="Link target outside of Sample">14 |  7–13 September</span></p>
<p class="toc1"><span href="#/xhtml/25_Chapter15" title="Link target outside of Sample">15 |  14–24 September</span></p>
<p class="toc1"><span href="#/xhtml/26_Chapter16" title="Link target outside of Sample">16 |  25–30 September</span></p>
<p class="toc1"><span href="#/xhtml/27_Chapter17" title="Link target outside of Sample">17 |  1–31 October</span></p>
<p class="toc1"><span href="#/xhtml/28_Chapter18" title="Link target outside of Sample">18 |  Loss</span></p>
<p class="toc1"><span href="#/xhtml/29_Chapter19" title="Link target outside of Sample">19 |  In memoriam</span></p>
<p class="toca"><span href="#/xhtml/30_Epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc1"><span href="#/xhtml/31_Acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc1"><span href="#/xhtml/32_Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc1"><span href="#/xhtml/33_Bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Contents.vue?0ec8fffd